import React from 'react';
import {postApi, deleteApi} from '../../../utils/functions';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../fontawesome/fontawesome';
import axios from 'axios';
import Gallery from 'react-photo-gallery';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ProgressBar from 'react-bootstrap/ProgressBar';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';

import './avatar.css';

export default class Avatar extends React.Component {
	constructor(props) {
    super(props);
		this.state = {
			show: this.props.show ? true : false,
			uid: this.props.uid,
			filename: '',
			percent: 0,
			gallery: [],
		};
		this.clickuploadFile = this.clickuploadFile.bind(this);
		this.uploadFile = this.uploadFile.bind(this);
		this.close = this.close.bind(this);
		this.Image = this.Image.bind(this);
		this.deleteImage = this.deleteImage.bind(this);
	}

	async componentDidMount() {


		let params = new URLSearchParams();
		params.append('id', this.state.uid);
		const x = await postApi('/api/v2/profile/avatars', params);
		this.setState({gallery: x.data});
	}

	componentWillUnmount() {
	}

	clickuploadFile() {
		document.getElementById('upload').click();
	}

	close() {
		this.setState({ show: false });
		this.props.close();
	}

	async uploadFile(event) {
		if( event.target.files[0] ) {
			this.setState({filename: event.target.files[0].name});
			const params = new FormData();
			params.append("id", this.state.uid);
			params.append('file', event.target.files[0]);
			axios.put(`/api/v2/profile/avatar`, params, {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				withCredentials: true,
				onUploadProgress: (progressEvent) => {
					let percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
					this.setState({percent: percentCompleted});
				}
			})
			.then(res => {
				console.log(res);
				switch(res.status) {
					case 200:
						this.props.complete();
						break;
					default:
						this.setState({filename: res.data.message, percent: 0});
						break;
				}
			})
		}
	}

	async Image(event) {
		let params = new URLSearchParams();
		params.append("id", this.state.uid);
		params.append( 'avatar', event.target.currentSrc );
		await postApi('/api/v2/profile/avatar', params);
		this.props.complete();
	}

	
	async deleteImage(event) {
		if( window.confirm("Are you sure you wish to delete this image?") ) {
			let params = new URLSearchParams();
			params.append("id", this.state.uid);
			params.append( 'avatar', event );
			await deleteApi('/api/v2/profile/avatar', params);
			this.props.complete();
		}
	}


	render() {
		let helper = (props) => {
			//console.log(props);
			return (
				<div key={props.index} style={{position: 'relative'}}>
					<img src={props.photo.src} style={{width: props.photo.width, height: props.photo.height, margin: props.margin, padding: 1, cursor: 'pointer', border: '1px solid #555555'}} onClick={event=>this.Image(event)} />
					<div style={{position: 'absolute', right: 10, bottom: 10}}>
						<Button size="sm" variant="secondary" onClick={()=>this.deleteImage(props.photo.src)}><FontAwesomeIcon icon="trash" /></Button>
					</div>
				</div>
			)}
		return (
			<Modal show={this.state.show} onHide={this.close} backdrop="static" keyboard={false} size="xl" centered>
				<Modal.Header closeButton className="bg-dark">
					<Modal.Title>Upload Avatar</Modal.Title>
				</Modal.Header>
				<Modal.Body className="bg-dark">

				
					<div className="upload-image">
						<Row onClick={this.clickuploadFile}>
							<Col xs={3} className="upload-file-outer">
								<div className="text-center upload-file-box">
									<div className="text-center upload-file-arrow">
										<button>
											<FontAwesomeIcon icon="cloud-arrow-up" />
										</button>

										<input id="upload" type="file" onChange={this.uploadFile} style={{display: 'none'}} />
									</div>
								</div>
							</Col>
							<Col>
								<div className="upload-file-info">
									<div className="float-right">
										{this.state.percent>0&&`${this.state.percent}%`}
									</div>
									<div className="">
										{this.state.filename.length>0?this.state.filename.substring(0,40):`Click to upload file`}<br />
										Best Resolution: 140px x 140px<br />
										Allowed File types: PNG, JPG and GIF
									</div>
									<div className="">
										<ProgressBar animated now={this.state.percent} />
									</div>
								</div>
							</Col>
						</Row>
					</div>
					<Row>
						<Col xs={12}>
							<Gallery photos={this.state.gallery} renderImage={helper} />
						</Col>
					</Row>

				</Modal.Body>
				<Modal.Footer className="bg-dark">
					<Button variant="secondary" onClick={this.close}>
						Close
					</Button>
					{this.state.access&&
						<Button variant="primary" onClick={this.submitEvent}>Add Event</Button>
					}
				</Modal.Footer>
			</Modal>
		)
	}
}